import ResultBaccarat from '../resultBaccarat/ResultBaccarat';

/**
 * Baccarat 2 / Premium Baccarat last results — same reference markup and result modal as Baccarat
 * (ResultBaccarat), fetched for the given game type.
 */
const ResultBaccarat2 = ({ gameType = 'baccarat2', ...props }) => <ResultBaccarat gameType={gameType} {...props} />;

export default ResultBaccarat2;
